<template>
  <div class="tw-w-full tw-relative set-overflow-hidden">
    <div class="tw-bg-lightblue tw-pb-36 tw-bg-contain tw-bg-center md:tw-rounded-b-max"
         :style="{
         'background-image': `url(${require('@/assets/images/intermarche/stars.png')})`,
       }">
      <div v-if="!isACEF" class="tw-hidden md:tw-flex tw-flex tw-relative tw-flex-row-reverse tw-items-start tw-justify-center tw-z-20">
        <img class="tw-block tw--ml-10" src="@/assets/images/intermarche/phone-folders.png" alt="Phone" width="500"
             data-aos="fade-left" data-aos-once="true">
        <img class="tw-block tw--mr-10 tw-mt-6" src="@/assets/images/intermarche/phone-contents.png" alt="Phone" width="500"
             data-aos="fade-right" data-aos-delay="200" data-aos-once="true">
      </div>
      <div class="tw-flex tw-justify-center tw-items-center tw-relative tw-z-20 tw-h-[500px]" v-if="isACEF">
  <div class="tw-relative tw-w-full tw-flex tw-justify-center">
    <img
      class="tw-block tw-mx-auto"
      src="@/assets/images/intermarche/app-mob-group-img.svg?url"
      alt="Phone"
      style="width: 70%;"
      data-aos="fade-left"
      data-aos-once="true"
    />
  </div>
</div>

      <img v-if="!isACEF" class="tw-hidden md:tw-block tw-mx-auto tw-mt-6" src="@/assets/images/intermarche/intermarche-logo.png" alt="Intermarche" width="420"
           data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
      <img v-if="isACEF" class="tw-hidden md:tw-block tw-mx-auto tw-mt-6" src="@/assets/images/intermarche/ACEF.png" alt="Intermarche" width="420"
           data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
      <img v-if="!isACEF" class="tw-block md:tw-hidden tw-mx-auto tw-mt-6" src="@/assets/images/intermarche/intermarche-logo-2.png" alt="Intermarche" width="160"
           data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
      <img v-if="isACEF" class="tw-block md:tw-hidden tw-mx-auto tw-mt-6" src="@/assets/images/intermarche/ACEF.png" alt="Intermarche" width="200"
      data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
      <div class="tw-mt-8 tw-px-6 tw-text-white set-text-bold tw-text-2xl md:tw-text-3xl tw-text-center title-shadow"
           data-aos="fade-down" data-aos-delay="400" data-aos-once="true">
        Plus de <span class="tw-text-yellow">4500 vidéos, livres audio et jeux éducatifs</span><br>
        dans 3 applications et sur tous vos écrans
      </div>
      <img v-if="!isACEF" class="tw-block tw-mx-auto tw-mt-8 tw-w-52 md:tw-w-auto" src="@/assets/images/intermarche/kidjo-tv-stories-logo.png" alt="Kidjo"
           data-aos="fade-down" data-aos-delay="600" data-aos-once="true" id="form-top">
      <feature-cards id="form-top"/>
  <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-bg-transparent md:tw-py-14">
  <div class="tw-w-full tw-max-w-sm tw-flex tw-flex-col tw-items-center tw-px-4">
    
    <!-- Form -->
    <form
      class="tw-w-full tw-flex tw-flex-col tw-gap-y-4 tw-text-center tw-font-nunito"
      @submit.prevent="handleSubmit"
      data-aos="fade-up"
      data-aos-once="true"
    >
      <!-- Email Input -->
      <div class="tw-w-full" data-aos="fade-down" data-aos-delay="100">
        <TextInputField
          :modelValue="email"
          @update:modelValue="email = $event"
          :field-type="'text'"
          name="email"
          :placeholder="'E-mail'"
          :has-error="emailError"
          :is-required-value="true"
          :is-coupon-field="false"
        />
      </div>

      <!-- Password Input -->
      <div class="tw-w-full" data-aos="fade-down" data-aos-delay="200">
        <TextInputField
          :modelValue="password"
          @update:modelValue="password = $event"
          :field-type="'password'"
          name="password"
          :placeholder="'Mot de passe'"
          :has-error="passwordError"
          :is-required-value="true"
          :is-coupon-field="false"
        />
      </div>

      <!-- Coupon Input -->
      <div class="tw-w-full" data-aos="fade-down" data-aos-delay="300">
        <TextInputField
          :modelValue="coupon"
          @update:modelValue="coupon = $event"
          :field-type="'text'"
          name="coupon"
          :placeholder="'Code promo'"
          :has-error="false"
          :is-required-value="false"
          :is-coupon-field="true"
        />
      </div>

      <!-- Submit Button -->
      <div class="tw-w-full" data-aos="fade-down" data-aos-delay="400">
        <SubmitButton :label="'S’enregistrer'" :isLoading="false" type="submit" :isBold="true" class="tw-font-bold set-btn-text-bold" />
      </div>
    </form>

    <!-- Support Text -->
    <div
        class="tw-text-center tw-text-white tw-font-nunito tw-mt-5 sm:tw-whitespace-nowrap tw-whitespace-normal tw-break-words"
        data-aos="fade"
        data-aos-delay="500"
      >
        Un souci pour entrer votre code ? Contactez 
        <a class="tw-font-bold tw-underline" href="mailto:support@kidjo.tv">support@kidjo.tv</a>
      </div>

  </div>
</div>



    </div>
    <div>
      <img class="tw-block tw-w-full md:tw-w-510px tw-mx-auto tw-px-4 md:tw-px-0 tw--mt-36"
           src="@/assets/images/multi-device-lp.png" alt="Multi devices"
           data-aos="fade" data-aos-delay="600" data-aos-once="true">
      <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-y-16 md:tw-gap-x-12 tw-px-6 md:tw-px-36 tw-mt-16 md:tw-mt-10">
        <div class="tw-flex tw-flex-col tw-flex-1 tw-text-center"
             data-aos="fade" data-aos-once="true">
          <img class="tw-block tw-mx-auto" src="@/assets/images/intermarche/feature-listen.svg?url" alt="Audio">
          <div class="set-text-bold md:tw-font-nunito set-text-color tw-text-xl md:tw-text-2xl tw-mt-7">
            Des contenus ludo-éducatifs variés sélectionnés avec soin
          </div>
          <div class="tw-font-nunito set-text-color tw-mt-3 md:tw-mt-5 tw-text-sm md:tw-text-md">
            Des personnages et histoires emblématiques (Trotro, Sam Sam, Didou, Molang, Barbie, Sam Le Pompier,
            Les Contes de Perrault…)
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-flex-1 tw-text-center"
             data-aos="fade" data-aos-delay="200" data-aos-once="true">
          <img class="tw-block tw-mx-auto" src="@/assets/images/intermarche/feature-kids.svg?url" alt="Audio">
          <div class="set-text-bold md:tw-font-nunito set-text-color tw-text-xl md:tw-text-2xl tw-mt-7">
            3 applications pensées pour les enfants
          </div>
          <div class="tw-font-nunito set-text-color tw-mt-3 md:tw-mt-5 tw-text-sm md:tw-text-md">
            Une ergonomie conçue par des spécialistes pour les yeux et les mains des enfants.
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-flex-1 tw-text-center"
             data-aos="fade" data-aos-delay="400" data-aos-once="true">
          <img class="tw-block tw-mx-auto" src="@/assets/images/intermarche/feature-idea.svg?url" alt="Audio">
          <div class="set-text-bold md:tw-font-nunito set-text-color tw-text-xl md:tw-text-2xl tw-mt-7">
            De nombreuses fonctionnalités pédagogiques
          </div>
          <div class="tw-font-nunito set-text-color tw-mt-3 md:tw-mt-5 tw-text-sm md:tw-text-md">
            Les applications s'adaptent à tous les profils grâce à des contrôles parentaux dédiés, de nombreuses aides à la lecture et des quiz pour les 7-10 ans à la fin de chaque livre.
          </div>
        </div>
      </div>
      <div class="tw-mt-10">
        <div class="auto-slider-container">
          <div class="auto-slider-row">
            <img src="@/assets/images/intermarche/row-1/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/14.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/14.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-1/14.png" alt="Contenu">
          </div>
        </div>
        <div class="auto-slider-container">
          <div class="auto-slider-row reverse">
            <img src="@/assets/images/intermarche/row-2/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-2/13.png" alt="Contenu">
          </div>
        </div>
        <div class="auto-slider-container">
          <div class="auto-slider-row">
            <img src="@/assets/images/intermarche/row-3/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/14.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/14.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/1.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/2.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/3.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/4.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/5.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/6.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/7.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/8.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/9.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/10.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/11.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/12.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/13.png" alt="Contenu">
            <img src="@/assets/images/intermarche/row-3/14.png" alt="Contenu">
          </div>
        </div>
      </div>
      <img v-if="!isACEF" class="tw-hidden md:tw-block tw-mx-auto tw-mt-16" src="@/assets/images/intermarche/intermarche-logo.png"
           alt="Intermarche" width="520" data-aos="fade-down" data-aos-once="true">
      <img v-if="!isACEF" class="tw-block md:tw-hidden tw-mx-auto tw-mt-16" src="@/assets/images/intermarche/intermarche-logo-2.png"
           alt="Intermarche" width="215" data-aos="fade-down" data-aos-once="true">
      <img  v-if="isACEF" class="tw-hidden md:tw-block tw-mx-auto tw-mt-16" src="@/assets/images/intermarche/ACEF-2.svg?url"
           alt="Intermarche" width="350" data-aos="fade-down" data-aos-once="true">
      <a class="tw-block tw-w-52 md:tw-w-48 tw-rounded-xl tw-border-darkbrown tw-text-xl
                tw-outline-none tw-px-5 tw-py-2 md:tw-py-1.5 tw-mt-14 tw-mx-auto set-text-bold
                tw-cursor-pointer tw-transition-colors tw-ease-in tw-duration-200 tw-text-center button-int tw-font-bold set-btn-text-bold"
              data-aos="fade-down" data-aos-delay="200" data-aos-once="true" href="#form-top">
        Commencer
      </a>
      <div class="tw-relative tw-mx-auto tw-my-16 md:tw-my-16 md:tw-mb-36 tw-px-2 md:tw-px-0" style="max-width: 900px; width: 100%;">
        <div class="tw-mx-10">
          <div class="tw-relative tw-z-10 md:tw-h-16 tw-bg-white tw-flex tw-items-center tw-justify-center
                    tw-mx-auto tw--mb-8 tw-py-2 md:tw-py-0 tw-rounded-4xl tw-border-3 tw-border-lightblue
                    set-text-bold tw-text-lightblue tw-text-2.5xl md:tw-text-4xl tw-text-center"
               style="max-width: 520px; width: 100%;">
            Comment ça marche ?
          </div>
        </div>
        <div class="tw-w-full tw-bg-lightblue tw-px-6 md:tw-pl-44 md:tw-pr-24 tw-pt-24 tw-pb-40 md:tw-py-24 tw-rounded-4xl">
          <div class="tw-flex tw-flex-col tw-gap-y-10">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start"
                 data-aos="fade-down" data-aos-once="true">
              <div class="tw-w-12 tw-h-12 tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-white
                          tw-rounded-full tw-mb-4 md:tw-mb-0 md:tw-mr-8 set-text-bold tw-text-lightblue
                          tw-text-2.5xl">
                1.
              </div>
              <div class="set-text-bold tw-text-white tw-text-2.5xl tw-text-center md:tw-text-left">
                Une connexion simple via l’activation d’un unique code promotionnel
              </div>
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start"
                 data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
              <div class="tw-w-12 tw-h-12 tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-white
                          tw-rounded-full tw-mb-4 md:tw-mb-0 md:tw-mr-8 set-text-bold tw-text-lightblue
                          tw-text-2.5xl">
                2.
              </div>
              <div class="set-text-bold tw-text-white tw-text-2.5xl tw-text-center md:tw-text-left">
                Accès aux trois applications Kidjo TV, Kidjo Stories et Kidjo Games avec un même compte utilisateur
                <span class="tw-font-nunito">iOS / Android</span>
              </div>
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start"
                 data-aos="fade-down" data-aos-delay="400" data-aos-once="true">
              <div class="tw-w-12 tw-h-12 tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-white
                          tw-rounded-full tw-mb-4 md:tw-mb-0 md:tw-mr-8 set-text-bold tw-text-lightblue
                          tw-text-2.5xl">
                3.
              </div>
              <div class="tw-font-nunito tw-text-white tw-text-2.5xl tw-text-center md:tw-text-left">
                Après avoir <span class="set-text-bold">téléchargé les applis</span>, cliquez sur un contenu
                verrouillé puis <span class="set-text-bold">Se connecter</span> et connectez vous avec votre
                compte.
              </div>
            </div>
            <div class="tw-flex tw-justify-center md:tw-justify-start md:tw-items-start"
                 data-aos="fade-down" data-aos-delay="600" data-aos-once="true">
              <div class="md:tw-w-12 md:tw-h-12 tw-flex tw-flex-shrink-0 md:tw-mr-8">
              </div>
                <a class="tw-block tw-w-52 tw-rounded-xl tw-border-darkbrown tw-text-xl
                        tw-outline-none tw-px-5 tw-py-2.5 tw-text-white tw-text-center
                        tw-cursor-pointer tw-transition-colors tw-ease-in tw-duration-200
                        button-int tw-font-bold tw-font-extrabold"
                href="#form-top">
                Commencer
              </a>
            </div>
          </div>
        </div>
        <img class="tw-absolute tw-hidden md:tw-block tw--left-2 tw--bottom-24"
             src="@/assets/images/intermarche/garfield.png" alt="Garfield" width="220">
        <img class="tw-absolute tw-block md:tw-hidden tw-left-28 tw--bottom-28"
             src="@/assets/images/intermarche/garfield.png" alt="Garfield" width="160">
      </div>
      <div class="tw-px-6 md:tw-px-16 tw-mb-10 md:tw-mb-10 tw-pt-12 md:tw-pt-0">
      <kidjo-footer id="footer" 
				class="light"/>

      </div>
    </div>
  </div>
</template>
<script>
import AOS from "aos";
import "aos/dist/aos.css";

import PasswordService from "@/services/password.service";
import FeatureCards from "../../components/FeatureCards.vue";
import TextInputField from "../../components/TextInputField.vue"
import SubmitButton from "../../components/SubmitButton.vue";
import KidjoFooter from '../../components/KidjoFooter.vue';

export default {
  data() {
    return {
      email: '',
      emailError: '',
      password: '',
      passwordError: '',
      coupon: '',
      loading: false,
      websiteUrl: process.env.VUE_APP_WEBSITE_URL,
    }
  },
  computed: {
    isACEF() {
      return this.$route.path === '/ACEF';
    }
  },
  
  components: {
    "feature-cards": FeatureCards,
    "TextInputField": TextInputField,
    'SubmitButton': SubmitButton,
		"kidjo-footer": KidjoFooter,
  },
  mounted() {
    AOS.init();
  },
  methods: {
    handleSubmit: async function() {
      this.loading = true;
      const hasError = this.checkFields();

      if (!hasError) {
        const hash = PasswordService.SHA256(this.password);
        const data = {
          'email': this.email,
          'password': hash,
          'coupon': this.coupon,
          'env': 'web',
          'countryCode': this.$parent.countryCode
        };

        const registered = await this.$store.dispatch('registerUser', data);

        this.loading = false;
        if (registered.status !== true) {
          return this.handleError(registered);
        }

        if (registered.freeCampaign === true) {
          this.removeCouponFromStorage();
          return this.$router.push('/products').catch(()=>{});
        }

        this.$router.push('/subscribe').catch(()=>{});
      }
    },
    handleError: function(response) {
      if (response.status === 400) {
        if (response.data.code === 2) {
          return this.$parent.showFlashMessage(this.$t('error_message_email_invalid'));
        }

        if (response.data.code === 3) {
          return this.$parent.showFlashMessage(this.$t('error_message_coupon_invalid'));
        }

        if (response.data.code === 5) {
          return this.$parent.showFlashMessage(this.$t('error_message_email_already_taken'));
        }

        return this.$parent.showFlashMessage(this.$t('error_message_something_went_wrong'));
      }
    },
    checkFields: function() {
      let hasError = false;

      if (this.email === '') {
        this.emailError = true;
        hasError = true;
      }

      if (this.password === '') {
        this.passwordError = true;
        hasError = true;
      }

      return hasError;
    },
    goToForm() {
      const slider = document.getElementById('slider');
      const form = document.getElementById('form');

      form.style.display = 'block';
      slider.style.display = 'none';

      if (window.innerWidth <= 340) {
        window.scrollTo(0, 30);
      }
    },
    removeCouponFromStorage: function() {
      localStorage.removeItem('coupon');
      localStorage.removeItem('couponDurationCode');
    },
  },
}
</script>

<style>
  .title-shadow {
    text-shadow: 2px 0 0 rgba(109, 76, 65, 0.5);
  }
  .set-overflow-hidden {
    overflow-x: hidden;
  }
  .auto-slider-container {
    height: 156px;
    margin: 10px 0;
    overflow: hidden;
    position: relative;
  }

  .auto-slider-row {
    animation: row-anim 60s linear infinite;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    white-space: nowrap;
  }

  .auto-slider-row.reverse {
    animation: row-anim-reverse 60s linear infinite;
    left: auto;
    right: 0;
  }

  .auto-slider-row img {
    display: inline-block;
    margin: 0 6px;
    max-width: none;
  }

  @keyframes row-anim {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-50%, 0);
    }
  }

  @keyframes row-anim-reverse {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(50%, 0);
    }
  }
  .set-text-color {
    color: #020076;
  }
  .button-int {
    background-color: #FFA726;
    color: #020076;
    border: none;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px; /* Ensures consistency when switching between text and loader */
    position: relative;
    font-family: "Nunito-Regular";
    font-size: 16px;
    line-height: 1;
  }
  .set-text-bold {
    font-family: "Nunito-ExtraBold" !important;
  }
  .set-btn-text-bold {
    font-family: "Nunito-ExtraBold" !important;
  }
  .button-animation {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse_button 2s infinite;
  }
  .button-int:focus {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse_button 2s infinite;
  }
  .button-int:hover {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse_button 2s infinite;
  }
  @keyframes pulse_button {
			0% {
				transform: scale(0.95);
				box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);

      }

			70% {
				transform: scale(1);
				box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);

      }

			100% {
				transform: scale(0.95);
				box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);

      }

    }
  
.submit-text {
  padding: 0.55rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
  line-height: 0;
}
.submit-text::placeholder {
  color: #020076; /* Your desired color */
}
</style>

<style lang="sass">
.slide-fade-enter-active
  transition: all .3s ease

.slide-fade-leave-active
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0)

.slide-fade-enter, .slide-fade-leave-to
  transform: translateX(10px)
  opacity: 0
</style>